import { memo } from 'react';

import { Dialog } from '../Dialog';
import { DialogContent } from '../DialogLayout';
import { Button, ButtonProps } from '../Button';
import { cn } from '../../lib/styles';

export interface ToastDialogProps {
  icon?: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  open?: boolean;
  trigger?: React.ReactNode;
  confirmButtonProps?: ButtonProps & { text?: string };
  className?: string;
  overlayClassName?: string;
  titleClassName?: string;
  descriptionClassName?: string;
  onConfirm?: () => void;
}

const ToastDialogBase = ({
  open,
  title,
  description,
  icon,
  trigger,
  confirmButtonProps = {},
  className,
  overlayClassName,
  titleClassName,
  descriptionClassName,
  onConfirm,
}: ToastDialogProps) => {
  const {
    text: confirmText = 'Done',
    variant: confirmVariant = 'primary',
    size: confirmSize = 'lg',
    color: confirmColor = 'default',
    className: confirmClassName,
    ...confirmButtonRest
  } = confirmButtonProps;

  const handleConfirm = () => {
    onConfirm?.();
  };

  return (
    <Dialog overlayClassName={overlayClassName} className={className} trigger={trigger} open={open}>
      <DialogContent className="flex flex-col items-center gap-2 px-14 py-10 w-[420px]">
        {typeof icon === 'string' ? <h2 className="text-[40px] leading-15">{icon}</h2> : icon}

        <h3 className={cn('font-heading-2xl font-semibold text-text-primary text-center', titleClassName)}>{title}</h3>

        {description ? (
          <p className={cn('font-body-md text-text-tertiary text-center', descriptionClassName)}>{description}</p>
        ) : null}

        <div className="flex flex-col items-center mt-4 w-full px-12">
          <Button
            size={confirmSize}
            variant={confirmVariant}
            color={confirmColor}
            className={cn('w-full', confirmClassName)}
            onClick={handleConfirm}
            {...confirmButtonRest}
          >
            {confirmText}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export const ToastDialog = memo(ToastDialogBase);
